import { WinLossPostModel } from "../models/WinLossModel";
import { client } from "./API";

const WinLossService = {
  async getProjectBidStatusHistory(projectId: number) {
    const response = await client({
      method: "GET",
      url: `Project/GetProjectWinlossStatus/${projectId}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },

  async postProjectBidStatus(data: WinLossPostModel) {
    try {
      const response = await client({
        method: "post",
        url: "Project/PostProjectWinlossStatus",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default WinLossService;
